import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { AppStorage } from '../utils';
import * as constants from '../constants';

export const AdminRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props => (
        AppStorage.get(constants.TOKEN_USER)
            ? (
                // Check if logged user is a teacher
                AppStorage.get(constants.CURRENT_ROLE) === constants.ADMIN ?
                <Component {...props} />
                : <Redirect to={{ pathname: '/not-authorized', state: { from: props.location } }} />
              )
            : <Redirect to={{ pathname: '/', state: { from: props.location } }} />
    )} />
)